import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ProductButton from '../product_button/ProductButton';
import { productsActions } from '../../actions';
import { productsObjectsSelector } from '../../selectors/products';
import iconButtonProps from './icon_button_props';

function IconAddToBag({ product, loading, addToBag }) {
  const addToBagClickHandler = (eventId) => {
    addToBag({ id: product.id, variantId: product.variantId, eventId });
  };

  return (
    <ProductButton
      {...iconButtonProps(product)}
      loading={loading}
      buttonColor="black"
      addToBagClickHandler={addToBagClickHandler}
    />
  );
}

IconAddToBag.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number.isRequired,
    variantId: PropTypes.number.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
  addToBag: PropTypes.func.isRequired,
};

IconAddToBag.defaultProps = {
  loading: false,
};

const mapStateToProps = (state, ownProps) => {
  const stored = productsObjectsSelector(state)
    .find((item) => item.id === ownProps.product.id);
  return { loading: Boolean(stored && stored.loading) };
};

const mapDispatchToProps = (dispatch) => ({
  addToBag: (payload) => dispatch(productsActions.addToBagRequest(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IconAddToBag);
